export default "__VITE_ASSET__BAbDbomP__"